import _ from 'lodash';
import { layouts } from '@/utils/layout';
import {
  getStaticMarketList, getCustomMarketList, saveCustomMarket, removeCustomMarket,
} from '@/services/market';

const state = {
  layouts,
  selectedLayout: null,
  staticMarkets: [],
  customMarkets: [],
  selectedMarkets: [],
  audio: false,
  pendingMarketInput: null,
};

/* eslint-disable no-param-reassign, no-shadow */
const getters = {
  selectedMarketIds(state) {
    return _(state.selectedMarkets).map('id').compact().value();
  },
};

const actions = {
  load({ state, dispatch, commit }) {
    if (!state.selectedLayout) {
      commit('setLayout', layouts[0]);
    }
    return Promise.all([
      dispatch('loadStaticMarkets'),
      dispatch('loadCustomMarkets'),
    ]);
  },
  loadStaticMarkets({ commit }) {
    return getStaticMarketList()
      .then((staticMarkets) => {
        commit('setStaticMarkets', staticMarkets);
      });
  },
  loadCustomMarkets({ commit }) {
    commit('setCustomMarkets', getCustomMarketList());
  },
  importCustomMarket({ dispatch }, customMarket) {
    saveCustomMarket(customMarket);
    return dispatch('loadCustomMarkets');
  },
  removeCustomMarket({ dispatch, commit }, id) {
    removeCustomMarket(id);
    commit('unselectMarket', id);
    return dispatch('loadCustomMarkets');
  },
};

const mutations = {
  setLayout(state, layout) {
    state.selectedLayout = layout;
    state.selectedMarkets = new Array(layout.marketCount);
  },
  selectMarket(state, { market, index }) {
    state.selectedMarkets.splice(index, 1, market);
  },
  unselectMarket(state, marketId) {
    const index = _.findIndex(state.selectedMarkets, { id: marketId });
    if (index !== -1) {
      state.selectedMarkets.splice(index, 1, null);
    }
  },
  setAudio(state, audio) {
    state.audio = audio;
  },
  setStaticMarkets(state, staticMarkets) {
    state.staticMarkets = _.sortBy(staticMarkets, 'id');
  },
  setCustomMarkets(state, customMarkets) {
    state.customMarkets = _.sortBy(customMarkets, 'name');
  },
  setPendingMarketInput(state, activeInput) {
    state.pendingMarketInput = activeInput;
  },
};
/* eslint-enable no-param-reassign, no-shadow */

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
